module.exports = __webpack_public_path__ + "img/cq25d-banner.d42ad26b.png";